<template>
  <div>
    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row"></div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--7">
      <div class="card card-stats" show-footer-line="true">
        <!---->
        <div class="card-body dashboard-top-status">
          <section id="section-1" class="p-3">
            <div class="row close-bottom">
              <div class="col-md-11"></div>
              <div class="col-md-1">
                <router-link to="/profile/dashboard">
                  <div title="بازگشت به داشبورد" class="close"></div>
                </router-link>
              </div>
            </div>
            <section>
              <div class="card-header">
                <h4 class="profile-sec-title">افزودن کانتر</h4>
              </div>
              <form>
                <div class="">
                  <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                      <div class="select">
                        <select class="select-text" v-model="selectedSource">
                          <option v-for="item in getSourceConfirmed" :value="item.id" :key="item.id">
                            {{ item.name }}
                          </option>
                        </select>
                        <p class="text-danger" v-if="
                          !$v.selectedSource.required &&
                          $v.selectedSource.$dirty
                        ">
                          لطفا آژانس را انتخاب نمائید
                        </p>
                        <span class="select-highlight"></span>
                        <span class="select-bar"></span>
                        <label class="select-label">آژانس</label>
                      </div>
                    </div>
                    <div class="
                        group_mdi
                        inputContainer
                        col-md-6 col-sm-6 col-lg-6
                      ">
                      <input type="text" v-model="user.name" @blur="$v.user.name.$touch()"
                        :class="{ invalid: $v.user.name.$error }" />
                      <i class="icon-user-outline"></i>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>نام کانتر</label>
                      <p class="text-danger" v-if="!$v.user.name.required && $v.user.name.$dirty">
                        لطفا نام کانتر را وارد کنید
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="group_mdi inputContainer col-md-6">
                      <input type="text" v-model="user.firstName" @blur="$v.user.firstName.$touch()"
                        :class="{ invalid: $v.user.firstName.$error }" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>نام</label>
                      <i class="icon-user-outline"></i>
                      <p class="text-danger" v-if="
                        !$v.user.firstName.required &&
                        $v.user.firstName.$dirty
                      ">
                        لطفا نام را وارد کنید
                      </p>
                    </div>
                    <div class="group_mdi inputContainer col-md-6">
                      
                      <input type="text" v-model="user.lastName" @blur="$v.user.lastName.$touch()"
                        :class="{ invalid: $v.user.lastName.$error }" />
                        <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>نام خانوادگی</label>
                      <i class="icon-user-outline"></i>
                      <p class="text-danger" v-if="
                        !$v.user.lastName.required && $v.user.lastName.$dirty
                      ">
                        لطفا نام خانوادگی را وارد کنید
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="group_mdi inputContainer col-md-6">
                      <input style="direction: ltr !important" type="email" v-model="user.email"
                        @blur="$v.user.email.$touch()" :class="{ invalid: $v.user.email.$error }" />
                      <i class="icon_mail_alt"></i>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>پست الکترونیک</label>
                      <p class="text-danger" v-if="!$v.user.email.required && $v.user.email.$dirty">
                        لطفا پست الکترونیک را وارد کنید
                      </p>
                      <p class="text-danger" v-if="!$v.user.email.email">
                        پست الکترونیک وارد شده معتبر نمی باشد
                      </p>
                      <p class="text-danger" v-if="$v.user.email.$error">
                        پست الکترونیک وارد شده تکراری می باشد
                      </p>
                    </div>

                    <div class="group_mdi inputContainer col-md-6">
                      <input type="number" maxlength="11" v-model="user.cellPhoneNumber"
                        @blur="$v.user.cellPhoneNumber.$touch()" :class="{ invalid: $v.user.cellPhoneNumber.$error }" />
                      <i class="icon-phone"></i>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>تلفن همراه</label>
                      <p class="text-danger" v-if="
                        !$v.user.cellPhoneNumber.required &&
                        $v.user.cellPhoneNumber.$dirty
                      ">
                        لطفا تلفن همراه را وارد کنید
                      </p>
                      <p class="text-danger" v-if="
                        !$v.user.cellPhoneNumber.minLength &&
                        $v.user.cellPhoneNumber.$dirty
                      ">
                        لطفا تلفن همراه را به طور صحیح وارد نمائید
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="group_mdi inputContainer col-md-6">
                      <input type="password" v-model="user.password" @blur="$v.user.password.$touch()"
                        :class="{ invalid: $v.user.password.$error }" />
                      <i class="icon_lock_alt"></i>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>رمزعبور</label>
                      <p class="text-danger" v-if="
                        user.password.length < 6 && $v.user.password.$dirty
                      ">
                        کلمه عبور حداقل شامل 6 کاراکتر باشد
                      </p>
                      <!-- <p
                class="text-danger"
                v-if="
                  (user.password.length < 8 ||
                    passwordValidation.errors.length) &&
                  $v.user.password.$dirty
                "
              >
                کلمه عبور باید حداقل شامل 8 حرف باشد، شامل حروف کوچک، بزرگ و
                حداقل یک کاراکتر خاص باشد
              </p> -->
                    </div>
                    <div class="group_mdi inputContainer col-md-6">
                      <input type="password" v-model="user.confirmPassword" @blur="$v.user.confirmPassword.$touch()"
                        :class="{ invalid: $v.user.confirmPassword.$error }" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <i class="icon_lock_alt"></i>
                      <label>تکرار رمزعبور</label>
                      <p class="text-danger" v-if="
                        !$v.user.confirmPassword.required &&
                        $v.user.confirmPassword.$dirty
                      ">
                        لطفا تکرار رمزعبور را وارد کنید
                      </p>
                      <p class="text-danger" v-if="!$v.user.confirmPassword.sameAsPassword">
                        تکرار کلمه عبور صحیح نمی باشد
                      </p>
                    </div>
                  </div>
                  <div class="text-center margin-btn">
                    <button v-if="!isLoading" type="submit" class="btn btn-primary" @click.prevent="save"
                      :disabled="$v.$invalid" :class="{ disabledBtn: $v.$invalid }">
                      ثبت
                    </button>

                    <button v-if="isLoading" type="submit" class="btn btn-primary">
                      ثبت
                      <loadingBar type="ring" class="loading-btn"></loadingBar>
                    </button>

                    <button type="submit" class="btn-info btn" @click.prevent="goBackToList">
                      بازگشت
                    </button>
                  </div>
                </div>
              </form>
            </section>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store/index";
import uri from "../../../../public/publicUries";
import loadingBar from "../../../components/loading/pdkLoadingBar";

import {
  required,
  email,
  maxLength,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  store,
  components: { loadingBar },
  data() {
    return {
      id: "",
      selectedSource: "",
      user: {
        userName: "",
        firstName: "",
        lastName: "",
        email: "",
        cellPhoneNumber: "",
        password: "",
        confirmPassword: "",
        individualType: 3, // کانتر
        userId: "",
        name: "",
      },

      profile: {
        id: "",
        creatorProfileID: "",
        name: "",
        profileType: 3, // کانتر
        status: 1,
      },

      rules: [
        { message: "شامل حداقل یک حروف کوچک باشد.", regex: /[a-z]+/ },
        { message: "شامل حداقل یک حروف بزرگ باشد.", regex: /[A-Z]+/ },
        { message: "شامل حداقل یک کاراکتر خاص باشد.", regex: /[!@#$%^&*()_+]/ },
      ],

      isLoading: false,
      sources: [],
    };
  },
  validations: {
    selectedSource: { required },
    user: {
      name: { required },
      firstName: { required },
      lastName: { required },
      email: {
        required,
        email,
        maxLength: maxLength(100),

        async isUnique(email) {
          if (email.length > 5) {
            const valid = await this.$store.dispatch(
              "CheckEmailExist",
              this.user.email
            );
            if (valid.data === "The Email Address Was Not Found!") {
              return true;
            } else return false;
          }
        },
      },
      cellPhoneNumber: {
        required,
        maxLength: maxLength(11),
        minLength: minLength(11),
      },
      password: { required, minLength: minLength(6) },
      confirmPassword: { required, sameAsPassword: sameAs("password") },
    },
  },
  computed: {
    passwordValidation() {
      let errors = [];
      for (let condition of this.rules) {
        if (!condition.regex.test(this.user.password)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    },
    getSourceConfirmed() {
      this.sources = this.$store.getters.GetAllSourceConfirmed;
      return this.$store.getters.GetAllSourceConfirmed;
    },
  },

  methods: {
    async save() {
      this.isLoading = true;
      const relatedProfileId = this.sources.filter(
        (p) => p.id == this.selectedSource
      );

      const relationModel = {
        parentProfileId: "00000000-0000-0000-0000-000000000000",
        relatedProfileId: relatedProfileId[0].profileId,
        relationTypeId: 0,
      };
      const register = await this.$store.dispatch("counterRegister", {
        profileModel: {
          id: null,
          creatorProfileID: localStorage.getItem("UserId"),
          name: this.user.name, // نام کانتر
          profileType: 3, // کانتر
          status: 4, // تائید شده
          createdDate: "",
          individualModel: [this.user],
          isUpdatedPassword: true, // سرویس سی ار اس در زمان لاگین فراخوانی نشود
          ProfileRelationCreateModel: [relationModel],
        },
        password: this.user.password,
        confirmPassword: this.user.confirmPassword,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email,
        phoneNumber: this.user.cellPhoneNumber,
        sourceProfileId: relatedProfileId[0].profileId,
        parentProfileId: localStorage.getItem("UserId"),
        parentSourceId: localStorage.getItem("SourceIdInReport"),
      });

      if (register.status == 200) {
        this.isLoading = false;

        this.$toast.success(" برای فعال سازی حساب کاربری ایمیل تائید را چک نمائید. در صورت عدم وجود در Inbox  لطفا بخش Spam را نیز چک فرمایید", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });

        // alert(
        //   " ثبت نام اولیه با موفقیت انجام شد، برای فعال سازی حساب کاربری ایمیل تائید را چک نمائید. "
        // );
        this.goBackToList();
      } else {
        this.$toast.error(" خطا در ثبت اطلاعات ", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
        this.isLoading = false;
      }
    },
    goBackToList() {
      this.$router.push({ name: "counters" });
    },
  },
};
</script>

<style scoped>
.form-control {
  font-size: 13px;
  color: #333;
  height: 40px;
  border-radius: 3px;
  padding-right: 40px;
}

.card-title {
  font-weight: 300;
}

.btn {
  font-size: 14px;
  margin-top: 20px;
}

.login-form {
  width: 800px;
  margin: 20px;
}

.card-body {
  padding: 30px 15px 30px 15px;
  line-height: 1.6 !important;
  border-top: 0px solid;
}

.inputContainer i {
  font-size: 20px;
  color: #11bddbad;
  margin-bottom: 6px;
  margin-right: -8px;
}

.inputContainer {
  width: 100%;
  margin-bottom: 10px;
}

.cancel-btn {
  border: none;
  font-family: inherit;
  font-size: inherit;
  color: #fff;
  width: 100%;
  background: #8f8f8f;
  cursor: pointer;
  padding: 12px 20px;
  display: inline-block;
  outline: 0;
  font-size: 12px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  text-transform: uppercase;
  font-weight: 700;
  display: block;
  text-align: center;
  margin-bottom: 10px;
}

.margin-btn {
  margin-top: 25px;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  margin-bottom: 30px;
}
</style>